'use client';
import ShopUI from "@/app/(pages)/store/ShopUI";
export default function StorePage() {
    return (
        <ShopUI/>
    )
}
